module.exports = __webpack_public_path__ + "static/media/pic38.48e02774.jpg";